import React, { useState, useEffect } from 'react';
import TextAreaTail from './Components/textarea-tail';
import ButtonTail from './Components/button-tail';
import RadioGroupTail from './Components/radiogroup-tail';

function App() {
  const [score, setScore] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [quiz, setQuiz] = useState(null);
  const [userAnswers, setUserAnswers] = useState([]);
  useEffect(() => {
    if (quiz) {
      setUserAnswers(Array(quiz.questions.length).fill(null));
    }
  }, [quiz]);

  const handleAnswerChange = (questionIndex, answerIndex) => {
    const newAnswers = [...userAnswers];
    newAnswers[questionIndex] = answerIndex.toString();
    setUserAnswers(newAnswers);
  };

  const submitQuiz = () => {
    let newScore = 0;
    quiz.questions.forEach((question, index) => {
      if (userAnswers[index] === question.correctAnswer.toString()) {
        newScore++;
      }
    });
    setScore(newScore);
    setSubmitted(true);
  };

  const updateQuiz = (newQuiz) => {
    setSubmitted(false);
    setQuiz(newQuiz);
  };

  return (
    <div className="App p-4 flex flex-col items-center">
      <div class="mt-12">
        <h1 className="text-4xl mb-4">Generate Your Quiz with AI 🔮</h1>
      </div>
      <div class="mb-8">
        <p className="mb-4">Enter the topic of your quiz and we'll generate your questions in under a minute</p>
      </div>
      <div className="w-full max-w-xl">
        <TextAreaTail updateQuiz={updateQuiz} />
      </div>
        {quiz && (
        <div className="w-full max-w-xl mt-4">
          <h1 className="text-2xl mb-4">{quiz.name}</h1>
          {quiz.questions && quiz.questions.map((question, index) => (
            <div key={index} className="mb-4">
              <p className="mb-2">{question.question}</p>
              <RadioGroupTail
                key={quiz.name}
                notificationMethods={question.answers.map((answer, i) => ({ id: i.toString(), title: answer, value: i }))}
                defaultChecked={userAnswers[index]?.toString()}
                index={index}
                correctAnswer={question.correctAnswer}
                submitted={submitted}
                userAnswer={userAnswers[index]}
                simpleExplanation={question.simpleExplanation}
                citation={question.citation}
                onChange={(e) => {
                  const answerIndex = parseInt(e.target.value, 10);
                  handleAnswerChange(index, answerIndex);
                }}
              />
            </div>
          ))}
        </div>
      )}
        {quiz && (
          <ButtonTail onClick={submitQuiz} text="Submit Quiz" />
        )}
        {submitted && (
          <p className="mt-4">
            Your score: {score}/{quiz.questions.length}
          </p>
        )}
      </div>
  );
}

export default App;
